/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Notebook = "Notebook",
    Register = "register",
    Login = "login",
    EasterEgg = "Easteregg",
    ClockPuzzle = "clockpuzzle",
    wereldmap = "wereldmap",
};
